<template>
  <div class=" candidates-table">
    <table>
      <thead class="headers">
      <tr>
        <th width="30%">Persoon</th>
        <th width="50%">Vacature</th>

        <th>Start op</th>
      </tr>
      </thead>
      <tbody>
      <tr :key=idx v-for="(data,idx) in latestPlacings">
       <template v-if="data.candidate">
        <td><strong>{{data.candidate ? data.candidate.firstName : ""}} {{data.candidate.lastName}}</strong></td>
        <td>{{data.vacancy ? getVacancyName(data.vacancy.name) : ' '}}</td>
        <td>{{ data.startDate | europeminus}}</td>
       </template>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
  export default {
    name: 'candidates-table',
    props: ['dashboardData'],
    computed: {
      latestPlacings() {
        let placements = this.dashboardData.placements
        placements.map(placement => {
          placement.candidate = _.find(this.dashboardData.candidates, {'id': placement.candidateId})
          placement.vacancy = _.find(this.dashboardData.vacancies, {'id': placement.vacancyId})
          return placement
        })
        placements = placements.sort(function compare(a, b) {
          var dateA = a.created_at && a.created_at._seconds ? new Date(a.created_at._seconds * 1000) : new Date(a.created_at);
          var dateB = b.created_at && b.created_at._seconds ? new Date(b.created_at._seconds * 1000) : new Date(b.created_at);
          return dateB - dateA;
        });

        let sliced = placements.slice(0, 10)
        return sliced
      }
    },
    methods: {
      getVacancyName(name) {
        let str = name.substr(0, 20)
        if(name.length > 20)
          str += '..'
        return str
      }
    }
  }

</script>

<style lang="scss" scoped>
  /* table */
  table {
    height: 900px;
    table-layout: fixed;
    background-color: white;
    width: 100%;
  }




  .second-row {
    .candidates-table {
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3) !important;
    }

    /* table */
    table {

      height: 900px;
      table-layout: fixed;
      background-color: white;
      width: 100%;
    }

    td, th {
      text-align: left;

    }

    th {
      font-size: 70px;
      color: #25b7bc;;
      line-height: 90px;
      padding-left: 30px;
      background-color: white;
    }

    td {
      font-size: 50px;
      width: 100%;
      color: #505050;
      padding-left: 30px;

      line-height: 85px;
    }

    tr {
      background-color: white;
    }

    tr:nth-child(odd) {
      background-color: #F0F0F0;

    }

  }

</style>